import type { OrderAnalytics, TransactionColumnFilters } from '../models/types';

export const SEARCH_DEBOUNCE_MS = 400;

export const DONUT_COLORS = [
  '#5c6bc0', '#26a69a', '#ffa502', '#ff6b81', '#a78bfa', '#2ed573', '#ff9f43',
];

export const AVATAR_COLORS = [
  '#5c6bc0', '#26a69a', '#f59e0b', '#a78bfa', '#ef4444', '#3b82f6',
];

export const HEATMAP_TYPES = ['Card', 'Transfer', 'Crypto'] as const;

export const EMPTY_ANALYTICS: OrderAnalytics = {
  totalVolume: 0,
  weeklyTransactionCount: 0,
  previousWeekTransactionCount: 0,
  transactionChangePercent: 0,
  totalCompletedTransactions: 0,
  totalFailedTransactions: 0,
  totalPendingTransactions: 0,
  totalRefundTransactions: 0,
  totalChargebackTransactions: 0,
  totalOrdersCount: 0,
  totalProcessingTransactions: 0,
  totalAwaitingCheckoutTransactions: 0,
  volumeTrend: [],
  paymentTypes: [],
  topCurrencies: [],
  countryTransactions: {},
  hourlyTrend: {},
  acquirerSplit: [],
  merchantSplit: [],
  terminalApprovalRates: [],
};

export const EMPTY_TRANSACTION_COLUMN_FILTERS: TransactionColumnFilters = {
  merchantName: null,
  transactionId: null,
  dateOnly: null,
  timeOnly: null,
  acquirerName: null,
  acquirerTerminalName: null,
  amount: null,
  currency: null,
  customerName: null,
  customerEmail: null,
  country: null,
  status: null,
  mode: null,
  merchantTerminalName: null,
  message: null,
};
